module.exports = "/_next/static/images/loading_03-3b0a409f37d2cf873bd1af81976ac4d6.png";